import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class CreateBooking {
    static buildRequest(pCreateBookingReq) {
        let returnValue = null;
        // console.error(pCreateBookingReq);
        try {
            if (
                pCreateBookingReq &&
                pCreateBookingReq.sessionId &&
                pCreateBookingReq.pId &&
                pCreateBookingReq.paxList
            ) {


                if (pCreateBookingReq.paxList && pCreateBookingReq.paxList.length) {

                    pCreateBookingReq.paxList.forEach(pax => {
                        if (pax) {

                            if (pax.title)
                                pax.title = pax.title.toString().trim();
                            if (pax.firstname)
                                pax.firstname = pax.firstname.toString().trim();
                            if (pax.lastname)
                                pax.lastname = pax.lastname.toString().trim();
                            if (pax.docnumber)
                                pax.docnumber = pax.docnumber.toString().trim();
                            if (pax.mobile_number)
                                pax.mobile_number = pax.mobile_number.toString().trim();
                            if (pax.paxemail)
                                pax.paxemail = pax.paxemail.toString().trim();
                        }

                    });
                }
                let body = {
                    sessionId: pCreateBookingReq.sessionId,
                    pId: pCreateBookingReq.pId,
                    agentRef: pCreateBookingReq.agentRef,
                    passengers: pCreateBookingReq.paxList,
                    "ref_staffName":pCreateBookingReq.ref_staffName,
                    "remarks": pCreateBookingReq.remarks,
                    "subAgentId": pCreateBookingReq.subAgentId,
                    "paidAmount":pCreateBookingReq.paidAmount
                };

                returnValue = body;
            } else {
                returnValue = null;
            }
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_BOOKING,
                "error in building body for Create Booking  api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.CREATE_BOOKING,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_BOOKING,
                "error in getting Response from   Create Booking api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}